export function copy (text: string): void {
  if (!text) return

  if (navigator && "clipboard" in navigator) {
    navigator.clipboard.writeText(text)
  }
}
